import { render, staticRenderFns } from "./AccountQuick.vue?vue&type=template&id=2580bbb2&scoped=true&"
import script from "./AccountQuick.vue?vue&type=script&lang=js&"
export * from "./AccountQuick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2580bbb2",
  null
  
)

export default component.exports